/**
 * Created by flj on 2019/3/26 .
 */
import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';
import './index.less';

const prefixCls = 'eh-container-component';

class Container extends (PureComponent || Component) {
	render () {
		const { style } = this.props;

  	return (
  		<section className={prefixCls}>
  			<div className={`${prefixCls}-innerbox`} style={style}>
					{this.props.children}
  			</div>
  		</section>
  	);
	}
}

Container.propTypes = {
	// 样式
	style: PropTypes.object
};

export default Container;
